import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Breadcrumb } from './Breadcrumb';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { Colors } from '../../../../play-core/styles/Colors';
import { hideScrollbar } from '../../../../play-core/styles/style-helper';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { usePath, useVideoConfig } from '../../config/VideoAppContext';
import { createSeparatedList } from '../../utils/separated-list-helper';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const Breadcrumbs = ({
  topic,
  show
}) => {
  const {
    t
  } = useTranslation();
  const analytics = useAnalyticsDispatch();
  const {
    showsSupported
  } = useVideoConfig();
  const {
    videoShowPath,
    topicPath,
    homePath
  } = usePath();
  const ResponsiveChevron = /*#__PURE__*/_jsx(BreadcrumbsChevron, {
    icon: /*#__PURE__*/_jsx(SvgChevron, {
      orientation: "right"
    }),
    color: Colors.GREY_969696
  });
  const breadcrumbList = [/*#__PURE__*/_jsx(Breadcrumb, {
    title: t('global.homepage'),
    link: homePath,
    onClick: () => {
      analytics({
        type: 'click-event',
        name: 'BreadcrumbClick',
        value1: 'home'
      });
    }
  }, homePath), topic && /*#__PURE__*/_jsx(Breadcrumb, {
    title: topic.title,
    link: topicPath(topic.title),
    onClick: () => {
      analytics({
        type: 'click-event',
        name: 'BreadcrumbClick',
        value1: 'topic',
        value2: topic.urn,
        value3: topic.title
      });
    }
  }), show && showsSupported && /*#__PURE__*/_jsx(Breadcrumb, {
    title: show.title,
    link: videoShowPath(show),
    onClick: () => {
      analytics({
        type: 'click-event',
        name: 'BreadcrumbClick',
        value1: 'show',
        value2: show.id,
        value3: show.title
      });
    }
  })];
  const breadcrumbSeparatedList = createSeparatedList(breadcrumbList, ResponsiveChevron);
  return /*#__PURE__*/_jsx(BreadcrumbsContainer, {
    children: /*#__PURE__*/_jsx(BreadcrumbsHorizontalScrollContainer, {
      children: breadcrumbSeparatedList
    })
  });
};
const BreadcrumbsContainer = styled.div.withConfig({
  displayName: "Breadcrumbs__BreadcrumbsContainer",
  componentId: "sc-c3qk3l-0"
})(["overflow-x:scroll;max-width:calc(100% + 16px);", ""], hideScrollbar);
const BreadcrumbsHorizontalScrollContainer = styled.div.withConfig({
  displayName: "Breadcrumbs__BreadcrumbsHorizontalScrollContainer",
  componentId: "sc-c3qk3l-1"
})(["display:flex;flex-wrap:nowrap;margin-right:8px;> a:first-child{padding-left:0;}> a:last-child{padding-right:8px;}"]);

// ResponsiveChevron for the Breadcrumbs Seperator
const BreadcrumbsChevron = styled(IconWrapper).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "Breadcrumbs__BreadcrumbsChevron",
  componentId: "sc-c3qk3l-2"
})(["font-size:16px;"]);